import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GeaoContext } from '../../../GeaoContextProvider';
import { GeaoPaths } from '../../../constants/GeaoPaths';
import { getAnswer } from '../../../mappers/InterviewMapper';

export default function useNavigation(
    interviewsUpdated,
    exitAfterSave
) {
    const { agencyInterview } = useContext(GeaoContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!interviewsUpdated) return; // Only navigate if the interview update was successful.

        if (exitAfterSave) {
            navigate(GeaoPaths.CreateYourProfileChecklist);
            return;
        }

        const affiliatedWithTop100 = getAnswer(agencyInterview, "AffiliatedWithTop100") === "true";
        const firmNetworkAggregatorCommissionPayments = getAnswer(agencyInterview, "FirmNetworkAggregatorCommissionPayments") === "true";
        const agencyCommissionPayments = getAnswer(agencyInterview, "AgencyCommissionPayments") === "true";

        if ((affiliatedWithTop100 && firmNetworkAggregatorCommissionPayments) || !agencyCommissionPayments) {
            navigate(GeaoPaths.PrincipalErrorsAndOmissions);
        }
        else {
            navigate(GeaoPaths.PrincipalBankingInformation);
        }
    }, [agencyInterview, interviewsUpdated, exitAfterSave]);
}